import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class ConfigurationService {

    getConfigurations(params, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configurations',
                method: 'get',
                params: params,
                withCredentials: true,
headers: {                   'Authorization': token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getConfiguration(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration/' + uuid,
                method: 'get',
                withCredentials: true,
headers: {                   'Authorization': token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postConfiguration(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration',
                method: 'post',
                withCredentials: true,
headers: {                   'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putConfiguration(uuid, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration/' + uuid,
                method: 'put',
                withCredentials: true,
headers: {                   'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }



    deleteConfiguration(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/configuration/' + uuid,
                method: 'delete',
                withCredentials: true,
headers: {                   'Authorization': token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}